import styled from '@emotion/styled'
import { css } from '@emotion/react'
import mq from 'theme/mediaQueries'
import { NavLink } from 'ui-components/NavLink'
import { Button } from 'ui-components/Button'
import { Card as CardComponent } from 'ui-components/Card'

const shadow = `0px 2px 1px -1px rgb(0 0 0 / 20%),
                0px 1px 1px 0px rgb(0 0 0 / 14%),
                0px 1px 3px 0px rgb(0 0 0 / 12%)`

export const hide = css`
  ${mq({
    opacity: ['0', '0', '1'],
  })}
  z-index: -1;
`

export const List = styled.ul`
  margin: 0;
  background-color: inherit;
  transition: opacity .3s ease;
  border-radius: 5px;
  min-width: 180px;
  z-index: 100;

  ${mq({
    position: ['absolute', 'absolute', 'initial'],
    padding: ['10px 40px 10px 20px', '10px 40px 10px 20px', '0 10px'],
    boxShadow: [shadow, shadow, 'none'],
    marginTop: ['-10px', '-10px', '0'],
  })}
`

export const ListItem = styled.li`
  list-style: none;
  padding: 10px 0;
`

export const Link = styled(NavLink)`
  text-decoration: none;
  font-size: 14px;
  padding: 10px 0;
`

export const HeaderMenu = styled.div`
  padding-bottom: 10px;

  ${mq({
    display: ['grid', 'grid', 'block'],
    gridTemplateColumns: ['30px auto'],
  })} 
`

export const MenuTitle = styled.h5`
  margin-top: 5px;
  margin-bottom: 0;
`

export const MoreButton = styled(Button)`
  padding: 0;

  ${mq({
    display: ['block', 'block', 'none'],
  })}
`

export const Card = styled(CardComponent)`
  ${mq({
    padding: ['20px 20px 10px', '20px 20px 10px', '30px'],
    marginBottom: ['20px', '20px', '0'],
  })}
`
